// Kepler Shop Theme JavaScript

(function() {
  'use strict';

  // Product image gallery
  const productThumbnails = document.querySelectorAll('.thumbnail');
  const productMainImage = document.getElementById('productMainImage');

  if (productThumbnails.length > 0 && productMainImage) {
    productThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const imageUrl = this.getAttribute('data-image-url');
        productMainImage.src = imageUrl;
      });
    });
  }

  // Product variant selection
  const variantSelects = document.querySelectorAll('.variant-select');
  const productForm = document.getElementById('productForm');

  if (variantSelects.length > 0 && productForm) {
    variantSelects.forEach(select => {
      select.addEventListener('change', updateVariant);
    });
  }

  function updateVariant() {
    // This function would update the selected variant based on option selections
    // In a full implementation, this would match variant combinations
    // and update the hidden variant ID input
  }

  // Cart functionality
  const addToCartBtn = document.querySelector('.add-to-cart-btn');

  if (addToCartBtn && productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      const formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Show success message or update cart count
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  }

  // Subcategory nav visibility
  const shopLink = document.querySelector('.nav-shop');
  const subcategoryNav = document.getElementById('subcategoryNav');

  if (shopLink && subcategoryNav) {
    shopLink.addEventListener('click', function(e) {
      // The subcategory nav is already visible on collection/product pages
      // This is just for interaction feedback
    });
  }

})();
